import moment from "moment";
import * as React from "react";
import { FileWithPreview } from "react-dropzone";
import { connect } from "react-redux";
import { Action, Dispatch } from "redux";
import {
  Field,
  formValueSelector,
  InjectedFormProps,
  reduxForm,
} from "redux-form";
import { frontEndConfig } from "../../../../../config/config";
import { projectConfig } from "../../../../../config/language/ja-JP/domain/model_text";
import { Project, Status } from "../../../../../domain/model/project";
import {
  createMonthArray,
  createYearsArray,
} from "../../../../../util/commonFuntion";
import {
  createAddressOptionDom,
  createNoRequiredOptionItem,
  createOptionsFromMap,
} from "../../../../../util/select_option_function";
import * as Validator from "../../../../../util/validation";
import BtnCorporateLarge from "../../../../common/atom/btn/btn_corporate_large";
import BtnLinkCancelSmall from "../../../../common/atom/btn/btn_link_cancel_small";
import StyledThumbnailDropZone from "../../../../common/atom/drop_zone/styled_thumbnail_drop_zone";
import ErrorText from "../../../../common/atom/text/error_text";
import DatepickerWrapper from "../../../../common/atom/wrapper/datepicker_wrapper/datepicker_wrapper";
import MonthDaysWrapper from "../../../../common/atom/wrapper/datepicker_wrapper/month_days_wrapper";
import YearWrapper from "../../../../common/atom/wrapper/datepicker_wrapper/year_wrapper";
import FormFieldWrapper from "../../../../common/atom/wrapper/form_field_wrapper";
import CancelButtonWrapper from "../../../../common/atom/wrapper/submit_btn_wrapper/cancel_button_wrapper";
import SubmitButtonWrapper from "../../../../common/atom/wrapper/submit_btn_wrapper/submit_btn_wrapper";
import SubmitErrorTextWrapper from "../../../../common/atom/wrapper/submit_error_text_wrapper";
import FormGroupCheckboxConnectRf from "../../../../common/molecular/form_group/form_group_checkbox_connect_rf";
import FormGroupInputConnectRf from "../../../../common/molecular/form_group/form_group_input_connect_rf";
import FormGroupMultiSelectConnectRf from "../../../../common/molecular/form_group/form_group_multi_select_connect_rf";
import FormGroupSelectConnectRf from "../../../../common/molecular/form_group/form_group_select_connect_rf";
import FormGroupTextareaConnectRf from "../../../../common/molecular/form_group/form_group_textarea_connect_rf";
import { AppState } from "../../../../store/app_state";

const uploadFileMaxSize = frontEndConfig.uploadFileMaxSize;

const validate = (values: any) => {
  const errors: any = {};
  return errors;
};

interface IStateProps {
  initialValues:
    | {
        project?: Project;
        thumbnailURLFileObject?: File;
      }
    | undefined;
  formValues: any;
}

interface IProps extends IStateProps {
  isLoading: boolean;
}

interface IState {
  imageError: string | null;
}

export class ClientProjectMainModifyForm extends React.Component<
  IProps & InjectedFormProps<{}, IProps>,
  IState
> {
  constructor(props: IProps & InjectedFormProps<{}, IProps>) {
    super(props);

    this.state = {
      imageError: null,
    };
  }

  public componentWillUpdate(nextProps: any, nextState: any): void {
    // 更新実行後の初期化処理
    if (
      this.props.formValues != null &&
      this.props.initialValues.project &&
      nextProps.initialValues.project.gsThumbnailURL !==
        this.props.initialValues.project.gsThumbnailURL
    ) {
      URL.revokeObjectURL(this.props.formValues.preview);
      this.props.change("thumbnailURLFileObject", null);
    }
  }

  public componentWillUnmount(): void {
    // Make sure to revoke the data uris to avoid memory leaks
    if (this.props.formValues != null) {
      URL.revokeObjectURL(this.props.formValues.preview);
    }
  }

  public render(): JSX.Element {
    const { anyTouched, invalid, handleSubmit, pristine, submitting } =
      this.props;

    const project: Project | undefined = this.props.initialValues.project;

    if (!project) {
      return <div />;
    }

    const thumbnailURL: string = project.getThumbnailURL();

    const updateThumbnailURL: string | null = this.props.formValues
      ? this.props.formValues.preview
      : null;

    let res: JSX.Element;

    // 編集ページ
    res = (
      <React.Fragment>
        <form name="clientProjectMainModifyForm" onSubmit={handleSubmit}>
          <StyledThumbnailDropZone
            name={"clientProjectMainModifyForm-dropzone"}
            handleOnDrop={this.handleOnDrop}
            updateThumbnailURL={updateThumbnailURL}
            thumbnailURL={thumbnailURL}
          />

          <FormFieldWrapper>
            <Field
              label={projectConfig.nameLabel}
              placeholder="入力してください"
              name="project.name"
              component={FormGroupInputConnectRf}
              type="text"
              validate={[Validator.projectName, Validator.required]}
              require={true}
            />
          </FormFieldWrapper>
          <FormFieldWrapper>
            <Field
              label={projectConfig.descriptionLabel}
              placeholder="入力してください"
              name="project.description"
              rows={5}
              component={FormGroupTextareaConnectRf}
              type="text"
              validate={[Validator.projectDescription, Validator.required]}
            />
          </FormFieldWrapper>
          <FormFieldWrapper>
            <Field
              label={projectConfig.backgroundLabel}
              placeholder="入力してください"
              name="project.background"
              rows={5}
              component={FormGroupTextareaConnectRf}
              type="text"
              validate={[Validator.projectBackground, Validator.required]}
            />
          </FormFieldWrapper>
          <FormFieldWrapper>
            <Field
              label={projectConfig.preferentialExperienceLabel}
              placeholder="入力してください"
              name="project.preferentialExperience"
              rows={5}
              component={FormGroupTextareaConnectRf}
              type="text"
              validate={[Validator.projectPreferentialExperience]}
            />
          </FormFieldWrapper>
          <FormFieldWrapper>
            <Field
              label={projectConfig.paymentRangeLabel}
              name="project.paymentRange"
              component={FormGroupSelectConnectRf}
              type="text"
            >
              {createNoRequiredOptionItem(projectConfig.paymentRangeList)}
            </Field>
          </FormFieldWrapper>
          <FormFieldWrapper>
            <Field
              label={projectConfig.workingHourRangeLabel}
              name="project.workingHourRange"
              component={FormGroupSelectConnectRf}
              type="text"
            >
              {createNoRequiredOptionItem(projectConfig.workingHourRangeList)}
            </Field>
          </FormFieldWrapper>
          <FormFieldWrapper>
            <Field
              label={projectConfig.placeLabel}
              name="project.place"
              component={FormGroupSelectConnectRf}
              type="text"
            >
              {createNoRequiredOptionItem(projectConfig.placeList)}
            </Field>
          </FormFieldWrapper>
          <FormFieldWrapper>
            <Field
              label={projectConfig.occupationsLabel}
              name="project.occupations"
              component={FormGroupMultiSelectConnectRf}
              type="select-multiple"
              isMulti={true}
              options={createOptionsFromMap(projectConfig.occupationList)}
            />
          </FormFieldWrapper>
          <FormFieldWrapper>
            <DatepickerWrapper>
              <YearWrapper>
                <Field
                  label={`${projectConfig.operatingDateLabel}：年`}
                  name={`project.operatingDate.year`}
                  component={FormGroupSelectConnectRf}
                  type="text"
                >
                  {createAddressOptionDom(
                    createYearsArray(10, Number(moment().year().toString()) + 4)
                  )}
                </Field>
              </YearWrapper>
              <MonthDaysWrapper>
                <Field
                  label={`${projectConfig.operatingDateLabel}：月`}
                  name={`project.operatingDate.month`}
                  component={FormGroupSelectConnectRf}
                  type="text"
                >
                  {createAddressOptionDom(createMonthArray())}
                </Field>
              </MonthDaysWrapper>
            </DatepickerWrapper>
          </FormFieldWrapper>
          <FormFieldWrapper>
            <Field
              label={projectConfig.workingDurationLabel}
              name="project.workingDuration"
              component={FormGroupSelectConnectRf}
              type="text"
            >
              {createNoRequiredOptionItem(projectConfig.workingDurationList)}
            </Field>
          </FormFieldWrapper>
          <FormFieldWrapper>
            <Field
              label="企業情報を非公開にする"
              name="project.isHideCompany"
              component={FormGroupCheckboxConnectRf}
            />
          </FormFieldWrapper>
          <FormFieldWrapper>
            <Field
              label={projectConfig.statusLabel}
              name="project.status"
              component={FormGroupSelectConnectRf}
              type="text"
            >
              <option value={Status.Status_Open}>
                {projectConfig.statusList[Status.Status_Open]}
              </option>
              <option value={Status.Status_OnlyScout}>
                {projectConfig.statusList[Status.Status_OnlyScout]}
              </option>
              <option value={Status.Status_Draft}>
                {projectConfig.statusList[Status.Status_Draft]}
              </option>
              <option value={Status.Status_Close}>
                {projectConfig.statusList[Status.Status_Close]}
              </option>
            </Field>
          </FormFieldWrapper>

          {anyTouched && invalid && (
            <SubmitErrorTextWrapper>
              <ErrorText>入力を完了してください</ErrorText>
            </SubmitErrorTextWrapper>
          )}

          <SubmitButtonWrapper>
            <CancelButtonWrapper>
              <BtnLinkCancelSmall to="/client/projects?p=1">
                キャンセル
              </BtnLinkCancelSmall>
            </CancelButtonWrapper>
            <BtnCorporateLarge
              name="clientProjectMainModifyForm-submit"
              type="submit"
              widthSize="200px"
              disabled={pristine || submitting || invalid}
            >
              保存
            </BtnCorporateLarge>
          </SubmitButtonWrapper>
        </form>
      </React.Fragment>
    );

    return res;
  }

  private handleOnDrop = (
    acceptedFiles: FileWithPreview[],
    rejectedFiles: FileWithPreview[]
  ): void => {
    try {
      this.setState({ imageError: null });

      if (rejectedFiles.length > 1) {
        throw new Error("複数のファイルが選択されました");
      } else if (
        rejectedFiles.length > 0 &&
        rejectedFiles[0].size > uploadFileMaxSize
      ) {
        throw new Error("ファイルサイズオーバ");
      } else {
        this.props.change("thumbnailURLFileObject", acceptedFiles[0]);
      }
    } catch (error) {
      this.setState({ imageError: error.message });
    }
  };
}

const selector = formValueSelector("clientProjectMainModifyForm");

const mapStateToProps = (state: AppState) => {
  return {
    formValues: selector(state, "thumbnailURLFileObject"),
  };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>) => {
  return {};
};

export default reduxForm({
  form: "clientProjectMainModifyForm",
  validate,
})(connect(mapStateToProps, mapDispatchToProps)(ClientProjectMainModifyForm));



// WEBPACK FOOTER //
// ./src/presentation/component/client/project/modify/client_project_main_modify_form.tsx